module.exports = __webpack_public_path__ + "img/masterclass-sesi-4.a5c30488.png";